import 'whatwg-fetch';

export const authHeaderName = 'X-Request-Verification-Token';

export default (headers = {}) =>
{
  const { WA, bonaPage_Token = '' } = window; // eslint-disable-line camelcase
  const authToken = (WA && WA.AdminPanel && WA.AdminPanel.token) || bonaPage_Token; // eslint-disable-line camelcase

  if (headers instanceof window.Headers)
  {
    const hewHeaders = new window.Headers(headers);

    hewHeaders.append(authHeaderName, authToken);

    return hewHeaders;
  }

  return { ...headers, [authHeaderName]: authToken };
};
